import { render } from "./vistas.vue?vue&type=template&id=3a22e572&scoped=true"
import script from "./vistas.vue?vue&type=script&lang=js"
export * from "./vistas.vue?vue&type=script&lang=js"

import "./vistas.vue?vue&type=style&index=0&id=3a22e572&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a22e572"]])

export default __exports__